<template>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
        ref="modal">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Nouveau corridoring</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row d-flex justify-content-center">
                        <div class="col-auto">
                            <input v-model="name" type="text" class="form-control m-3" placeholder="Nom du corridoring">
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                        <div class="col-4">
                            <div class="card table-nowrap table-card">
                                <div class="table-responsive">
                                    <table class="table mb-0 table-striped">
                                        <tbody>
                                            <tr v-for="balise in balises" :key="balise.id">
                                                <td>
                                                    <div class="form-check">
                                                        <input @change="onBaliseChange" v-model="selectedBalise"
                                                            :value="balise" type="radio" name="vehicleRadio"
                                                            class="form-check-input p-2 border border-5 border-dark-subtle">
                                                    </div>
                                                </td>
                                                <td>
                                                    <VehicleNameDisplay :balise="balise" :linkEnabled="false" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="col-8">
                            <!-- Mode création : Trajet (existant) ou Plage de dates -->
                            <div v-if="selectedBalise != null" class="d-flex flex-wrap gap-2 mb-2">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" id="modeDrive" value="drive"
                                        v-model="mode">
                                    <label class="form-check-label small" for="modeDrive">Depuis un trajet</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" id="modeRange" value="range"
                                        v-model="mode">
                                    <label class="form-check-label small" for="modeRange">Depuis une plage de
                                        dates</label>
                                </div>
                            </div>

                            <!-- Mode "trajet" : liste des trajets d'une journée -->
                            <div v-if="selectedBalise != null && mode === 'drive'" class="input-group mb-2">
                                <span class="input-group-text bg-secondary-subtle">Afficher les trajets pour la journée
                                    du :</span>
                                <input class="form-control" type="date" v-model="driveDate" @change="onDateChange"
                                    required>
                            </div>

                            <!-- Mode "plage de dates" : saisie début/fin à la seconde -->
                            <div v-if="selectedBalise != null && mode === 'range'" class="row g-2 mb-2">
                                <div class="col-12 col-lg-6">
                                    <div class="input-group input-group-sm">
                                        <span class="input-group-text bg-secondary-subtle">Début</span>
                                        <input class="form-control" type="datetime-local" step="1" v-model="rangeFrom"
                                            required>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <div class="input-group input-group-sm">
                                        <span class="input-group-text bg-secondary-subtle">Fin</span>
                                        <input class="form-control" type="datetime-local" step="1" v-model="rangeTo"
                                            required>
                                    </div>
                                </div>
                            </div>
                            <div v-if="selectedBalise == null" class="text-center mt-5">
                                <span class="text-muted small">Sélectionnez un véhicule pour visualiser les
                                    trajets</span>
                            </div>
                            <div v-else-if="mode === 'drive'" class="card table-nowrap table-card">
                                <div class="table-responsive">
                                    <table class="table mb-0 table-striped">
                                        <tbody>
                                            <tr v-if="drives != null && drives.length == 0" class="text-center">
                                                <td colspan="2" class="text-muted small py-3">Aucun trajet enregistré
                                                    avec ces critères</td>
                                            </tr>
                                            <tr v-for="drive in drives" :key="drive.id">
                                                <td
                                                    :class="(selectedDrive && selectedDrive.id === drive.id) ? 'bg-info bg-opacity-25' : ''">
                                                    <div class="form-check">
                                                        <input v-model="selectedDrive" :value="drive" type="radio"
                                                            name="driveRadio"
                                                            class="form-check-input p-2 border border-5 border-dark-subtle">
                                                    </div>
                                                </td>
                                                <td
                                                    :class="(selectedDrive && selectedDrive.id === drive.id) ? 'bg-info bg-opacity-25' : ''">
                                                    <FullDriveDisplay :baliseDrive="drive" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="d-flex justify-content-between align-items-center p-2">
                                    <div class="small text-muted">
                                        Page {{ page }}<span v-if="total"> / {{ Math.ceil(total / limit) }}</span>
                                        <span v-if="loading" class="ms-2 spinner-border spinner-border-sm"></span>
                                        <span v-if="error" class="text-danger ms-2">{{ error }}</span>
                                    </div>
                                    <div>
                                        <button class="btn btn-sm btn-outline-secondary me-2" @click="prevPage"
                                            :disabled="loading || page === 1">
                                            Précédent
                                        </button>
                                        <button class="btn btn-sm btn-outline-primary" @click="nextPage"
                                            :disabled="loading || !hasMore">
                                            Suivant
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="mode === 'range'" class="text-muted small mt-2">
                                Le corridoring sera construit à partir des positions de la balise dans l’intervalle
                                choisi.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <ButtonDisplay :ref="'closeButton'" :type="'cancel'" :text="'Annuler'" data-bs-dismiss="modal" />
                    <ButtonDisplay :type="'add'" :text="'Enregistrer'" :disabled="saveReady" @click="submit()" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'
import FullDriveDisplay from '@/components/display/FullDriveDisplay.vue'
import BaliseService from '@/services/balise.service.js'
import DrivesService from '@/services/drive.service'
import FormatHelper from '@/helpers/format.helper.js'


export default {
    components: {
        ButtonDisplay,
        VehicleNameDisplay,
        FullDriveDisplay
    },
    data() {
        return {
            name: null,
            selectedBalise: null,
            selectedDrive: null,
            balises: null,
            drives: [],
            driveDate: null,
            mode: 'drive', // 'drive' | 'range'
            rangeFrom: null, // datetime-local string
            rangeTo: null,   // datetime-local string
            page: 1,
            limit: 30,
            hasMore: false,
            loading: false,
            error: '',
            total: 0
        };
    },
    computed: {
        saveReady() {
            const hasName = this.name != null && this.name !== "";
            if (!hasName) return true;
            if (!this.selectedBalise) return true;
            if (this.mode === 'drive') {
                return this.selectedDrive == null;
            }
            // mode range
            return !(this.rangeFrom && this.rangeTo);
        }
    },
    watch: {
        driveDate() {
            this.page = 1;
            this.getDrives();
        }
    },
    mounted() {
        this.refreshData();
        // reset auto quand la modale se ferme (X, backdrop, bouton Annuler)
        const el = this.$refs.modal;
        if (el) el.addEventListener('hidden.bs.modal', this.resetModal);
    },
    beforeUnmount() {
        const el = this.$refs.modal;
        if (el) el.removeEventListener('hidden.bs.modal', this.resetModal);
    },
    methods: {
        refreshData() {
            BaliseService.getGroupBalisesLastPositions()
                .then(response => {
                    this.balises = FormatHelper.balisesResponseFormat(response.data);
                })
                .catch(e => {
                    console.log(e);
                });
        },
        onBaliseChange() {
            this.selectedDrive = null;
            this.page = 1;
            // Par défaut on reste en mode "trajet" (cohérent avec l’existant)
            if (this.mode === 'drive') this.getDrives();
        },
        onDateChange() {
            // doublon du watcher pour déclencher instantanément
            this.page = 1;
            this.getDrives();
        },
        async getDrives() {
            if (!this.selectedBalise) { this.drives = []; return; }
            try {
                this.loading = true;
                this.error = '';
                const offset = (this.page - 1) * this.limit;
                const start = this.driveDate == null ? null : FormatHelper.dateFormatUTC(this.driveDate);
                const end = this.driveDate == null ? null : FormatHelper.dateFormatUTC(this.driveDate, true);
                const response = await DrivesService.getBaliseDrives(this.selectedBalise.id, offset, this.limit, start, end);
                const rows = response?.data?.rows || [];
                const count = Number(response?.data?.count ?? rows.length);
                this.total = count;
                this.drives = FormatHelper.baliseDrivesFormat(rows);
                this.hasMore = (offset + rows.length) < count;
            } catch (e) {
                this.error = e?.response?.data?.message || e.message || 'Erreur de chargement';
                this.drives = [];
                this.hasMore = false;
            } finally {
                this.loading = false;
            }
        },
        nextPage() {
            if (this.hasMore && !this.loading) {
                this.page += 1;
                this.getDrives();
            }
        },
        prevPage() {
            if (this.page > 1 && !this.loading) {
                this.page -= 1;
                this.getDrives();
            }
        },
        resetModal() {
            this.name = null;
            this.selectedBalise = null;
            this.selectedDrive = null;
            this.drives = [];
            this.driveDate = null;
            this.mode = 'drive';
            this.rangeFrom = null;
            this.rangeTo = null;
            this.page = 1;
            this.hasMore = false;
            this.error = '';
        },
        // datetime-local -> ISO string (secondes conservées)
        toIso(dtLocal) {
            if (!dtLocal) return null;
            // dtLocal ex: "2026-02-18T16:05:30"
            const d = new Date(dtLocal);
            return isNaN(d.getTime()) ? null : d.toISOString();
        },
        submit() {
            if (this.saveReady) return;

            if (this.mode === 'drive') {
                this.$emit("chose", { mode: 'drive', driveId: this.selectedDrive.id, name: this.name });
                this.$refs.closeButton.click();
                return;
            }

            // mode range
            const fromIso = this.toIso(this.rangeFrom);
            const toIso = this.toIso(this.rangeTo);
            if (!fromIso || !toIso) return;

            this.$emit("chose", {
                mode: 'range',
                baliseId: this.selectedBalise.id,
                from: fromIso,
                to: toIso,
                name: this.name
            });
            this.$refs.closeButton.click();
        },
    }
}
</script>